"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _CordovaFileHelper = _interopRequireWildcard(require("./CordovaFileHelper"));

var _FileReaderWriterWrapper = _interopRequireDefault(require("../cordovaPluginWrappers/FileReaderWriterWrapper"));

var _ChunkedPromises = require("../utils/ChunkedPromises");

var _ContentParser = _interopRequireDefault(require("../KESI2/entities/ContentParser"));

var _config = _interopRequireDefault(require("../../targets/cord_eurofh_teams/config.js"));

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var _KESI2Helper = _interopRequireDefault(require("../KESI2/KESI2Helper"));

var KesiFileConsistencyHelper = /*#__PURE__*/function () {
  function KesiFileConsistencyHelper() {
    (0, _classCallCheck2["default"])(this, KesiFileConsistencyHelper);
  }

  (0, _createClass2["default"])(KesiFileConsistencyHelper, null, [{
    key: "checkTimestampEquality",
    value: function () {
      var _checkTimestampEquality = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(newFileList) {
        var folder,
            fileListExists,
            existingFileListFileEntry,
            existingFileList,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                folder = _args.length > 1 && _args[1] !== undefined ? _args[1] : _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER;
                _context.prev = 1;
                _context.next = 4;
                return _CordovaFileHelper["default"].fileExists(_CordovaFileHelper.LOCAL_FILENAMES.FILELIST, folder);

              case 4:
                fileListExists = _context.sent;

                if (!fileListExists) {
                  _context.next = 17;
                  break;
                }

                _context.next = 8;
                return _CordovaFileHelper["default"].readTextFile(_CordovaFileHelper.LOCAL_FILENAMES.FILELIST, folder);

              case 8:
                existingFileListFileEntry = _context.sent;
                existingFileList = JSON.parse(existingFileListFileEntry);

                if (!(existingFileList.timestamp && newFileList.timestamp && existingFileList.timestamp === newFileList.timestamp)) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", [true, null]);

              case 14:
                return _context.abrupt("return", [false, existingFileList]);

              case 15:
                _context.next = 18;
                break;

              case 17:
                return _context.abrupt("return", [false, null]);

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](1);
                console.log('error checking Timestamp equality');
                return _context.abrupt("return", [false, null]);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 20]]);
      }));

      function checkTimestampEquality(_x) {
        return _checkTimestampEquality.apply(this, arguments);
      }

      return checkTimestampEquality;
    }()
    /**
     * Reads the existing filelist and compares it to the given one
     */

  }, {
    key: "checkDataFilesConsistenciesAgainstExistingFilelistAndCopyConsistentFilesToUpdateFolderIfThereAreInconsistentFiles",
    value: function () {
      var _checkDataFilesConsistenciesAgainstExistingFilelistAndCopyConsistentFilesToUpdateFolderIfThereAreInconsistentFiles = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(fileList) {
        var folder,
            copyToUpdateFolder,
            dryRun,
            _yield$KesiFileConsis,
            _yield$KesiFileConsis2,
            isEqual,
            existingFileList,
            filesToCheck,
            oldFilesToCheck,
            oldFilesByFilename,
            consistentFileNames,
            inconsistentFiles,
            updatedIds,
            _args3 = arguments;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                folder = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER;
                copyToUpdateFolder = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
                dryRun = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
                _context3.next = 5;
                return KesiFileConsistencyHelper.checkTimestampEquality(fileList, folder);

              case 5:
                _yield$KesiFileConsis = _context3.sent;
                _yield$KesiFileConsis2 = (0, _slicedToArray2["default"])(_yield$KesiFileConsis, 2);
                isEqual = _yield$KesiFileConsis2[0];
                existingFileList = _yield$KesiFileConsis2[1];

                if (!isEqual) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return", []);

              case 11:
                if (!dryRun) {
                  _context3.next = 13;
                  break;
                }

                return _context3.abrupt("return");

              case 13:
                if (existingFileList) {
                  _context3.next = 16;
                  break;
                }

                console.log('there is no existingFileList -> return');
                return _context3.abrupt("return");

              case 16:
                // check if all files in the current filelist are referenced in the old one, too
                // if there is additional data, ignore for now
                filesToCheck = [];

                if (fileList.content) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.content));
                }

                if (fileList.sprites) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.sprites));
                }

                if (fileList.themes) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.themes));
                }

                if (fileList.settings) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.settings));
                }

                if (fileList.thumbs) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.thumbs));
                }

                oldFilesToCheck = [];

                if (existingFileList.content) {
                  oldFilesToCheck = [].concat((0, _toConsumableArray2["default"])(oldFilesToCheck), (0, _toConsumableArray2["default"])(existingFileList.content));
                }

                if (existingFileList.sprites) {
                  oldFilesToCheck = [].concat((0, _toConsumableArray2["default"])(oldFilesToCheck), (0, _toConsumableArray2["default"])(existingFileList.sprites));
                }

                if (existingFileList.themes) {
                  oldFilesToCheck = [].concat((0, _toConsumableArray2["default"])(oldFilesToCheck), (0, _toConsumableArray2["default"])(existingFileList.themes));
                }

                if (existingFileList.settings) {
                  oldFilesToCheck = [].concat((0, _toConsumableArray2["default"])(oldFilesToCheck), (0, _toConsumableArray2["default"])(existingFileList.settings));
                }

                if (existingFileList.thumbs) {
                  oldFilesToCheck = [].concat((0, _toConsumableArray2["default"])(oldFilesToCheck), (0, _toConsumableArray2["default"])(existingFileList.thumbs));
                }

                oldFilesByFilename = new _map["default"]();
                oldFilesToCheck.forEach(function (entry) {
                  oldFilesByFilename.set(entry.fileName, entry);
                });
                consistentFileNames = [];
                inconsistentFiles = [];
                updatedIds = [];
                filesToCheck.forEach(function (entry) {
                  var inconsistent = !oldFilesByFilename.has(entry.fileName) || entry.md5 !== oldFilesByFilename.get(entry.fileName).md5;

                  if (inconsistent) {
                    inconsistentFiles.push(entry);
                  } else {
                    consistentFileNames.push(entry.fileName);
                  }
                });
                _context3.prev = 34;

                if (!(_DeviceInfoHelper["default"].isAndroid() && consistentFileNames.length > 0 && inconsistentFiles.length > 0 && copyToUpdateFolder)) {
                  _context3.next = 41;
                  break;
                }

                _context3.next = 38;
                return _CordovaFileHelper["default"].copyFolder(folder, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER, true);

              case 38:
                inconsistentFiles.forEach( /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fileEntry) {
                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return _CordovaFileHelper["default"].deleteFile(fileEntry.fileName, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER);

                          case 2:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _context3.next = 47;
                break;

              case 41:
                if (!(consistentFileNames.length > 0 && copyToUpdateFolder)) {
                  _context3.next = 47;
                  break;
                }

                _context3.t0 = inconsistentFiles;
                _context3.next = 45;
                return _CordovaFileHelper["default"].copyFilesFromFolder(folder, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER, consistentFileNames);

              case 45:
                _context3.t1 = _context3.sent;
                inconsistentFiles = _context3.t0.concat.call(_context3.t0, _context3.t1);

              case 47:
                _context3.next = 53;
                break;

              case 49:
                _context3.prev = 49;
                _context3.t2 = _context3["catch"](34);
                console.error("Error copying files from ".concat(folder, " to ").concat(_CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER), consistentFileNames, _context3.t2);
                throw _context3.t2;

              case 53:
                return _context3.abrupt("return", inconsistentFiles);

              case 54:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[34, 49]]);
      }));

      function checkDataFilesConsistenciesAgainstExistingFilelistAndCopyConsistentFilesToUpdateFolderIfThereAreInconsistentFiles(_x2) {
        return _checkDataFilesConsistenciesAgainstExistingFilelistAndCopyConsistentFilesToUpdateFolderIfThereAreInconsistentFiles.apply(this, arguments);
      }

      return checkDataFilesConsistenciesAgainstExistingFilelistAndCopyConsistentFilesToUpdateFolderIfThereAreInconsistentFiles;
    }()
    /**
     *
     * Reads the filelist and checks if the md5sums of all referenced files are correct, thus reading *all* files
     * @param fileList
     * @param copyConsistentFilesToUpdateFolder
     * @param folder
     * @returns {Promise<*>} a list of all inconsistent files
     * @deprecated
     */

  }, {
    key: "checkDataFilesConsistencies",
    value: function () {
      var _checkDataFilesConsistencies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(fileList) {
        var copyConsistentFilesToUpdateFolder,
            folder,
            _yield$KesiFileConsis3,
            _yield$KesiFileConsis4,
            isEqual,
            filesToCheck,
            _args4 = arguments;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                copyConsistentFilesToUpdateFolder = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
                folder = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER;
                _context4.next = 4;
                return KesiFileConsistencyHelper.checkTimestampEquality(fileList);

              case 4:
                _yield$KesiFileConsis3 = _context4.sent;
                _yield$KesiFileConsis4 = (0, _slicedToArray2["default"])(_yield$KesiFileConsis3, 1);
                isEqual = _yield$KesiFileConsis4[0];

                if (!isEqual) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", []);

              case 9:
                filesToCheck = [];

                if (fileList.content) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.content));
                }

                if (fileList.sprites) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.sprites));
                }

                if (fileList.themes) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.themes));
                }

                if (fileList.thumbs) {
                  filesToCheck = [].concat((0, _toConsumableArray2["default"])(filesToCheck), (0, _toConsumableArray2["default"])(fileList.thumbs));
                }

                return _context4.abrupt("return", KesiFileConsistencyHelper.checkFileConsistencies(filesToCheck, folder, copyConsistentFilesToUpdateFolder));

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function checkDataFilesConsistencies(_x4) {
        return _checkDataFilesConsistencies.apply(this, arguments);
      }

      return checkDataFilesConsistencies;
    }()
    /**
     *
     * @param filesToCheck
     * @param foldername
     * @param copyConsistentFilesToUpdateFolder
     * @returns {Promise<*>} a list of all inconsistent files
     */

  }, {
    key: "checkFileConsistencies",
    value: function () {
      var _checkFileConsistencies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(filesToCheck, foldername) {
        var copyConsistentFilesToUpdateFolder,
            results,
            inconsistentFiles,
            consistentFileNames,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                copyConsistentFilesToUpdateFolder = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : false;
                _context6.prev = 1;
                _context6.next = 4;
                return (0, _ChunkedPromises.callPromisesInChunks)(filesToCheck, /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(entry) {
                    var fileEntry, md5hash;
                    return _regenerator["default"].wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.prev = 0;

                            if (entry.fileName) {
                              _context5.next = 3;
                              break;
                            }

                            return _context5.abrupt("return", null);

                          case 3:
                            _context5.prev = 3;
                            _context5.next = 6;
                            return _CordovaFileHelper["default"].getFileEntry(entry.fileName, foldername);

                          case 6:
                            fileEntry = _context5.sent;
                            _context5.next = 12;
                            break;

                          case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5["catch"](3);
                            return _context5.abrupt("return", {
                              fileName: entry.fileName,
                              md5: entry.md5
                            });

                          case 12:
                            if (!entry.md5) {
                              _context5.next = 18;
                              break;
                            }

                            _context5.next = 15;
                            return _FileReaderWriterWrapper["default"].getMd5Hash(fileEntry);

                          case 15:
                            md5hash = _context5.sent;

                            if (!(md5hash !== entry.md5)) {
                              _context5.next = 18;
                              break;
                            }

                            return _context5.abrupt("return", {
                              fileName: entry.fileName,
                              md5: entry.md5
                            });

                          case 18:
                            return _context5.abrupt("return", null);

                          case 21:
                            _context5.prev = 21;
                            _context5.t1 = _context5["catch"](0);
                            console.log('error while checking file consistencies', _context5.t1);

                          case 24:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[0, 21], [3, 9]]);
                  }));

                  return function (_x7) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 4:
                results = _context6.sent;
                inconsistentFiles = [];
                consistentFileNames = [];
                results.forEach(function (result) {
                  var inconsistent = result !== null && result !== undefined;

                  if (inconsistent) {
                    inconsistentFiles.push(result);
                  } else if (result !== null) {
                    consistentFileNames.push(result.fileName);
                  }
                });

                if (!copyConsistentFilesToUpdateFolder) {
                  _context6.next = 14;
                  break;
                }

                _context6.t0 = inconsistentFiles;
                _context6.next = 12;
                return _CordovaFileHelper["default"].copyFilesFromFolder(_CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER, consistentFileNames);

              case 12:
                _context6.t1 = _context6.sent;
                inconsistentFiles = _context6.t0.concat.call(_context6.t0, _context6.t1);

              case 14:
                return _context6.abrupt("return", inconsistentFiles);

              case 17:
                _context6.prev = 17;
                _context6.t2 = _context6["catch"](1);
                console.error('error checking file consistencies', _context6.t2);
                return _context6.abrupt("return", _promise["default"].resolve(null));

              case 21:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 17]]);
      }));

      function checkFileConsistencies(_x5, _x6) {
        return _checkFileConsistencies.apply(this, arguments);
      }

      return checkFileConsistencies;
    }() // async updateContent (onProgress, forced = false) {
    //   try {
    //     const updateFolder = await CordovaFileHelper.getUpdateFolder(true)
    //     let dataFolder = null
    //     try {
    //       dataFolder = await CordovaFileHelper.getFolderEntry(LOCAL_FILENAMES.DATA_FOLDER)
    //     }
    //     catch (error) {
    //       // do nothing
    //     }
    //     const fileList = await this.updateFileList(updateFolder)
    //
    //     if (!forced) {
    //       const previousPublished = await DataStore.getElementByPath(DATA_STORE_PATHS.FILELIST_PUBLISHED)
    //       if (previousPublished === fileList.published) {
    //         return Promise.resolve()
    //       }
    //     }
    //
    //     if (!fileList.success) {
    //       return Promise.reject(new Error('Filelist contains "success: false", so stopped parsing'))
    //     }
    //
    //     let filesToLoad = []
    //     let totalSize = 0
    //     if (fileList.mandatory && fileList.mandatory.files) {
    //       filesToLoad = [...filesToLoad, ...fileList.mandatory.files]
    //       totalSize += fileList.mandatory.size || 0
    //     }
    //     if (fileList.optional && fileList.optional.files) {
    //       filesToLoad = [...filesToLoad, ...fileList.optional.files]
    //       totalSize += fileList.optional.size || 0
    //     }
    //
    //     const metaData = {}
    //     let loaded = 0
    //
    //     const promises = filesToLoad.map(async entry => {
    //       if (!entry.url) {
    //         console.error('filelist entry without url: ', entry)
    //         return Promise.resolve()
    //       }
    //       const splitUrl = entry.url.split('/')
    //       const fileName = splitUrl[splitUrl.length - 1]
    //
    //       const previousMetaData = await DataStore.getElementByPath(`${DATA_STORE_PATHS.METADATA}.${fileName}`) || {}
    //       const previousMd5 = previousMetaData.md5
    //       const previousLastModified = previousMetaData.lastModified
    //
    //       console.log({
    //         fileName: fileName,
    //         previousLastModified: previousLastModified,
    //         lastModified: entry.lastModified,
    //         previousMd5: previousMd5,
    //         md5: entry.md5
    //       })
    //
    //       if (dataFolder && (previousLastModified === entry.lastModified) && (previousMd5 && entry.md5 && previousMd5 === entry.md5)) {
    //         await CordovaFileHelper.copyDirectoryOrFile(dataFolder, fileName, updateFolder, fileName)
    //         loaded += entry.size
    //         onProgress({
    //           lengthComputable: totalSize > 0,
    //           total: totalSize,
    //           loaded: loaded
    //         })
    //       }
    //       else {
    //         await CordovaFileHelper.downloadFile(`${HOST}${entry.url}`, updateFolder, fileName, entry.md5, false, (progressObj) => {
    //           loaded += progressObj.loaded
    //           onProgress({
    //             lengthComputable: totalSize > 0,
    //             total: totalSize,
    //             loaded: loaded
    //           })
    //         })
    //       }
    //
    //       metaData[fileName] = {
    //         lastModified: entry.lastModified,
    //         md5: entry.md5
    //       }
    //
    //       return Promise.resolve()
    //     })
    //
    //     await Promise.all(promises)
    //
    //     // now that the download has finished successfully move all files to the data folder and save DataStore metadata
    //     await CordovaFileHelper.moveFolder(LOCAL_FILENAMES.UPDATE_FOLDER, LOCAL_FILENAMES.DATA_FOLDER, true)
    //
    //     const data = {}
    //     data[DATA_STORE_PATHS.METADATA] = metaData
    //     data[DATA_STORE_PATHS.HOMECOURSE_ID] = fileList.id
    //     data[DATA_STORE_PATHS.FILELIST_PUBLISHED] = fileList.published
    //     await DataStore.setData(data)
    //
    //     console.log('SUCCESS: updating content')
    //     return Promise.resolve()
    //   }
    //   catch (error) {
    //     console.log('ERROR: updating content', error)
    //     return Promise.reject(error)
    //   }
    // }
    //
    // async updateFileList (folderEntry) {
    //   let path = `${HOST}/published/v2/courses/home/fileList`
    //
    //   console.log('updateFileList path', path)
    //
    //   try {
    //     const fileListPlain = await CordovaFileHelper.downloadFile(path, folderEntry, LOCAL_FILENAMES.FILELIST, null, true)
    //     const fileListJson = JSON.parse(fileListPlain)
    //     console.log('CourseDownloader FileList', fileListJson)
    //     return Promise.resolve(fileListJson)
    //   }
    //   catch (error) {
    //     console.log('error downloading or parsing json (filelist)', error)
    //     return Promise.reject(error)
    //   }
    // }

  }]);
  return KesiFileConsistencyHelper;
}();

var _default = KesiFileConsistencyHelper;
exports["default"] = _default;